import { cn } from "@/utils/classes";
import { ReactNode } from "react";

/* Prop Types */
interface FullPageLoaderProp {
  children: ReactNode;
  className?: string;
}

/*
 * Full Page Loader
 * Generic full page loader component
 */
export const FullPageLoader = ({ children, className }: FullPageLoaderProp) => {
  return (
    <div className="flex justify-center items-center fixed top-0 left-0 w-full z-50 h-full bg-base-100/70">
      <div className={cn("rounded-2xl max-w-xl w-full bg-base-100 shadow-xl p-6", className)}>{children}</div>
    </div>
  );
};
